import React from 'react'

function scripting(slice) {
  return {
    __html: `
      <script charset="utf-8" type="text/javascript" src="https://js.hsforms.net/forms/v2.js"></script>
      <script>
        hbspt.forms.create({
          region: "${slice.primary.hubspot_region}",
          portalId: "${slice.primary.hubspot_portal_id}",
          formId: "${slice.primary.hubspot_form_id}",
        })
      </script>
  `
  }
}

const Hubspot = ({ slice }) => {
  return (
    <section className='component-hubspot mx-auto max-w-screen-xl p-4'>
      <div className='mt-5 w-full rounded bg-white p-6 md:flex lg:px-10' key={`form-${slice.primary.hubspot_form_id}`} dangerouslySetInnerHTML={scripting(slice)} />
    </section>
  )
}

export default React.memo(Hubspot)
